export default __webpack_public_path__ + "static/media/1983.230ff0ec.png";